import PropTypes from 'prop-types'
import { NumericFormat } from 'react-number-format'
import Precios from '../reutilizables/precios/Precios'
import styles from './PresupuestoForm.module.css'

const PresupuestoFormItemList = ({
  item,
  idEstado,
  onDelete,
  onCancelarEliminar,
  puedeAdministrar
}) => {
  const marcadoEliminar = Boolean(item._marcadoEliminar)

  return (
    <div className={styles.itemContenedor}>
      <div
        className={`${styles.itemFila}${item._pendiente ? ` ${styles.itemFilaPendiente}` : ''}${marcadoEliminar ? ` ${styles.itemFilaEliminar}` : ''}`}
      >
        <div className={styles.itemCelda}>{item.descripcion}</div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaCentro}`} data-label="Cantidad">
          <NumericFormat
            value={item.cantidad}
            displayType={'text'}
            thousandSeparator={false}
            decimalSeparator={'.'}
            fixedDecimalScale={true}
            decimalScale={2}
          />
        </div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaDerecha}`} data-label="Precio">
          <Precios
            precio={item.precio}
            monedaSimbolo={item.monedaSimbolo}
            unidadMedida={item.unidadMedida}
          />
        </div>
        <div className={styles.itemCelda} data-label="Unidad">
          {item.unidadMedida}
        </div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaDerecha}`} data-label="Total">
          <Precios precio={item.total} monedaSimbolo={item.monedaSimbolo} />
        </div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaDerecha}`} data-label="% IVA">
          {item.alicuota ?? 0}%
        </div>
        <div className={`${styles.itemCelda} ${styles.itemCeldaDerecha}`}>
          {idEstado === 0 &&
            puedeAdministrar &&
            (marcadoEliminar ? (
              <button
                type="button"
                className={`${styles.btn} ${styles.btnAccionCuadrado}`}
                onClick={() => onCancelarEliminar(item.idPresupuestoItem)}
                title="Deshacer eliminación (se aplicará recién al guardar el presupuesto)"
              >
                <i className="bi bi-arrow-counterclockwise"></i>
              </button>
            ) : (
              <button
                type="button"
                className={`${styles.btn} ${styles.btnOutlineDanger} ${styles.btnAccionCuadrado}`}
                onClick={() => onDelete(item.idPresupuestoItem)}
                title="Eliminar item (se aplicará al guardar el presupuesto)"
              >
                <i className="bi bi-trash"></i>
              </button>
            ))}
        </div>
      </div>
    </div>
  )
}

PresupuestoFormItemList.propTypes = {
  item: PropTypes.shape({
    descripcion: PropTypes.string.isRequired,
    cantidad: PropTypes.number.isRequired,
    precio: PropTypes.number.isRequired,
    monedaSimbolo: PropTypes.string,
    unidadMedida: PropTypes.string,
    total: PropTypes.number.isRequired,
    idPresupuestoItem: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    alicuota: PropTypes.number,
    _pendiente: PropTypes.bool,
    _marcadoEliminar: PropTypes.bool
  }).isRequired,
  idEstado: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCancelarEliminar: PropTypes.func.isRequired,
  puedeAdministrar: PropTypes.bool.isRequired
}

export default PresupuestoFormItemList
